import React from 'react'
// Components
import Table from './Table/TableWithAdd'
// Additional

const Select: React.FC = () => {
  return (
    <>
      <Table />
    </>
  )
}

export default Select
